//引入vue
import Vue from 'vue';
//引入vue-router
import VueRouter from 'vue-router';
//第三方库需要use一下才能用
Vue.use(VueRouter)

import store from "@/assets/js/store.js";
import mslogin from '@/assets/js/msLogin.js';
import bind_modal from '@/components/AreaBind';

//引用页面
import shop from '@/views/shop.vue';
import detail from '@/views/detail.vue';
import task from '@/views/task.vue';
import basket from '@/views/basket.vue';
import order from '@/views/order.vue';
import discount from '@/views/discount.vue';
import help from '@/views/help.vue';
import ex from '@/views/ex.vue';
import w12 from '@/views/w12.vue';


//获取原型对象上的push函数
const originalPush = VueRouter.prototype.push
//修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}

//定义routes路由的集合，数组类型
const routes = [
    //单个路由均为对象类型，path代表的是路径，component代表组件
    {path:'/index',name :'shop',component:shop, meta: { isAuth:false, isZid : false,},},
    {path:"/detail/:sid",name :'detail',component:detail, meta: { isAuth:false, isZid : false,},},
    {path:"/task",component:task, meta: { isAuth:true, isZid : true,},},
    {path:"/basket",name :'basket',component:basket, meta: { isAuth:true, isZid : true,},},
    {path:"/order",component:order, meta: { isAuth:true, isZid : true,},},
    {path:"/discount",name :'discount',component:discount, meta: { isAuth:false, isZid : false,},},
    {path:"/help",name :'help',component:help, meta: { isAuth:true, isZid : true,},},
    {path:"/ex",name :'ex',component:ex, meta: { isAuth:true, isZid : true,},},
    {path:"/w12",name :'w12',component:w12, meta: { isAuth:false, isZid : false,},},
    //写个路径为空的路由
    {path:"",redirect: '/index'}    
]

//实例化VueRouter并将routes添加进去
const router=new VueRouter({
//ES6简写，等于routes：routes
    routes,
});

//全局前置路由守卫-- 初始化的时候被调用,每次路由切换之前被调用
router.beforeEach((to, from, next) => {
    //var userObj = JSON.parse(localStorage.getItem("userObj"));
    //判断是否进行校验
    if (to.meta.isAuth) {
      if (store.state.login) {
        if(store.state.userinfo.zid){
          next();
        }
        else{
          next("/");
          bind_modal();
        }

      } else {
        next("/");
        mslogin.open();
      }
    } else {
      next();
    }
});

//抛出这个这个实例对象方便外部读取以及访问
export default router
